export enum ResultStatus {
    OK = "ok",
    Error = "error",
    NotFound = "not_found",
    Uncaught = "uncaught",
    Aborted = "aborted",
}
